import React from "react";
import {
  ScatterChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Scatter,
} from "recharts";
import { ChartStrategy } from "./ChartStrategy";

export class HeatmapStrategy extends ChartStrategy {
  render() {
    const maxValue = Math.max(
      ...this.props.normalizedData.map((d) => d[this.props.yAxis]),
    );

    return (
      <ScatterChart {...this.commonProps}>
        <CartesianGrid stroke={this.props.gridColor} strokeDasharray="3 3" />
        <XAxis type="category" dataKey={this.props.xAxis} {...this.axisProps} />
        <YAxis type="category" dataKey={this.props.yAxis} {...this.axisProps} />
        <Tooltip content={<this.props.CustomTooltip />} />
        <Scatter
          data={this.props.normalizedData}
          shape={(props) => {
            const { cx, cy, payload } = props;
            const value = payload[this.props.yAxis];
            const intensity = Math.round((value / maxValue) * 255);
            const color = `rgb(255, ${255 - intensity}, ${255 - intensity})`;
            return (
              <rect
                x={cx - 20}
                y={cy - 20}
                width={40}
                height={40}
                fill={color}
                stroke="#fff"
              />
            );
          }}
        />
      </ScatterChart>
    );
  }
}
